import React, { createContext, useContext, useState } from 'react';

const PopupContext = createContext();

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};

export const PopupProvider = ({ children }) => {
  const [authPopupOpen, setAuthPopupOpen] = useState(false);
  const [accountPopupOpen, setAccountPopupOpen] = useState(false);

  const openAuthPopup = () => {
    setAuthPopupOpen(true);
    setAccountPopupOpen(false); // Close account popup if open
  };

  const openAccountPopup = () => {
    setAccountPopupOpen(true);
    setAuthPopupOpen(false); // Close auth popup if open
  };

  const closeAllPopups = () => {
    setAuthPopupOpen(false);
    setAccountPopupOpen(false);
  };

  const value = {
    authPopupOpen,
    accountPopupOpen,
    openAuthPopup,
    openAccountPopup,
    closeAllPopups,
    setAuthPopupOpen,
    setAccountPopupOpen
  };

  return (
    <PopupContext.Provider value={value}>
      {children}
    </PopupContext.Provider>
  );
};